var map = {
	"./About/routes/admin.js": 461,
	"./Appearance/routes/admin.js": 462,
	"./Assessment/routes/admin.js": 463,
	"./Course/routes/admin.js": 464,
	"./Dashboard/routes/admin.js": 465,
	"./Profile/routes/admin.js": 466,
	"./Submission/routes/admin.js": 467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;